module.exports = __webpack_public_path__ + "static/media/tick.88c39f26.svg";